var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.909091,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07216 11.8663L8.83679 10.3224L4.72979 14.4294C3.99718 13.7386 3.41891 12.8715 3.07216 11.8663ZM19.0481 11.2397L19.0487 11.2391C19.8067 10.4798 19.8071 9.24925 19.0484 8.49059C18.2891 7.73123 17.057 7.73083 16.2983 8.49086C15.5388 9.24964 15.5394 10.4802 16.2986 11.2394C17.0573 11.9981 18.2888 11.9977 19.0481 11.2397ZM9.27786 15.5103L9.27731 15.5109C8.51932 16.2702 8.51892 17.5018 9.27759 18.2604C10.037 19.0198 11.2666 19.0199 12.0261 18.2607C12.7862 17.502 12.7858 16.2699 12.0264 15.5106L12.0261 15.5103C11.2667 14.7522 10.0373 14.7522 9.27786 15.5103ZM19.7599 3.65399C21.9554 6.17832 21.852 10.0071 19.4496 12.4085L19.4496 12.4086L13.1956 18.6636C13.1956 18.6636 13.1956 18.6636 13.1956 18.6636C10.7941 21.065 6.96536 21.1684 4.44102 18.9738L8.97341 14.4414L10.3634 13.0514L13.8384 9.57641L15.2284 8.18641L15.2284 8.18638L19.7599 3.65399ZM12.7879 12.0003C12.028 12.7589 12.028 13.9911 12.7879 14.7497C13.5473 15.5088 14.7777 15.5088 15.5371 14.7497C16.297 13.9911 16.297 12.7589 15.5371 12.0003C14.7777 11.2412 13.5473 11.2412 12.7879 12.0003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoy);
export default __webpack_public_path__ + "static/media/soy.ec38e5777d55134b76bf0ebf5fc06474.svg";
export { ForwardRef as ReactComponent };